<template>
  <div>
    授权中...
    {{code}}
  </div>
</template>

<script>
    export default {
        name: "scope",
        data(){
            code
        },
        created(){
            let code = this.$route.query.token
            console.log(code)
            this.code = code
            if(code){
                sessionStorage.setItem('_token', code);
           
            }
        },
        methods:{
      
        }
    }
</script>

<style scoped>

</style>
